<template>
  <validation-provider :rules="{ cbRequired: !isOptional ? { question, stateResponse } : false }" :disabled="isOptional" v-slot="{ errors }" slim :immediate="validateImmediate">
    <div v-if="question.hspQuestionTypeId !== 5" class="d-md-table-row pb-4 pb-md-0">
      <div v-if="!isMatrixMode && errors[0]">
        <h6 class="text-danger mb-md-1">{{ errors[0] }}</h6>
      </div>
      <div class="d-block d-md-table-cell" :style="{ width: questionWidth, 'background-color': questionBkgrndColor }">
        <div v-if="isMatrixMode && errors[0]">
          <h6 class="text-danger mb-md-1">{{ errors[0] }}</h6>
        </div>
        <span v-html="number" class="number-text"></span><span v-html="question.questionText"></span>
      </div>
      <div
        v-for="response in question.responses"
        :key="response.hspResponseId"
        class="d-block d-md-table-cell text-md-center"
        :style="{ width: responseWidth, 'background-color': responsesBkgrndColor }">
        <base-checkbox
          :hspResponseId="response.hspResponseId"
          :checked="isChecked(response.hspResponseId, response.hspResponseTypeId)"
          :inline="true"
          @input="handleInput">
          <span class="d-none d-md-inline">&nbsp;</span><span v-html="response.responseTitle" class="d-md-none pl-2"></span>
        </base-checkbox>
      </div>
    </div>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { isDesktopSize } from 'src/modules/utils';

export default {
  components: {
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    hasAlternatingBkgrndColor: Boolean,
    alternatingBackColor: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    displayOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    validateImmediate: Boolean,
  },
  data() {
    return {
      defaultQuestionWidth: 40
    }
  },
  computed: {
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponse() {
      return this.$store.getters.getQuestionResponseIds(this.question.hspCategoryQuestionId);
    },
    isMatrixMode() {
      return isDesktopSize(this.windowWidth);
    },
    questionWidth() {
      if (isDesktopSize(this.windowWidth)) {
        return `${this.defaultQuestionWidth}%`;
      }

      return '100%';
    },
    responseWidth() {
      if (isDesktopSize(this.windowWidth)) {
        let width = (100 - this.defaultQuestionWidth) / this.question.responses.length;

        return `${width}%`;
      }

      return '100%';
    },
    questionBkgrndColor() {
      if (this.hasAlternatingBkgrndColor && isDesktopSize(this.windowWidth)) {
        return this.alternatingBackColor;
      }

      return this.questionBackColor;
    },
    responsesBkgrndColor() {
      // Display the alternating background color for the responses, if available and in desktop size (matrix configuration).
      if (this.hasAlternatingBkgrndColor && isDesktopSize(this.windowWidth)) {
        return this.alternatingBackColor;
      }

      return this.responsesBackColor;
    },
    ...mapGetters([
      'windowWidth',
      'activeSectionId',
      'displayTypeOptions'
    ]),
  },
  methods: {
    isChecked: function(hspResponseId, hspResponseTypeId) {
      if(this.stateResponse.indexOf(hspResponseId) >= 0) {
        return true;
      }

      return false;
    },
    handleInput: function(value, params) {
      this.$store.dispatch('setCheckboxesQuestionResponse', {
        include: value,
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: params.hspResponseId,
        hasTextField: params.hasTextField
      });
    }
  },
  created() {
    let displayOption = this.displayOptions
      .find(displayOption => displayOption.optionId === this.displayTypeOptions.MATRIX_QUESTION_WIDTH);

    if(displayOption) {
      this.defaultQuestionWidth = displayOption.optionValue;
    }
  }
}
</script>
